import React from 'react';
import { SkeletonRect, SkeletonText, SkeletonPill, SkeletonButton } from '../../../common/Skeleton';

const MobileSkeletonCard = () => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      {/* Header Section with Thumbnail and Title */}
      <div className="flex items-center p-4 border-b border-gray-100">
        {/* Thumbnail */}
        <div className="flex-shrink-0">
          <SkeletonRect width="w-20" height="h-20" rounded="lg" />
        </div>

        {/* Title and Content Counts */}
        <div className="ml-4 flex-1 space-y-3">
          {/* Title */}
          <SkeletonText widths={['w-3/4']} height="h-5" />

          {/* Content Count Icons */}
          <div className="flex items-center gap-3">
            <SkeletonButton width="w-12" height="h-4" rounded="md" />
            <SkeletonButton width="w-12" height="h-4" rounded="md" />
          </div>
        </div>
      </div>

      {/* Tags Section */}
      <div className="px-4 pb-2 pt-2">
        <div className="flex flex-wrap gap-1">
          <SkeletonPill width="w-16" height="h-6" />
          <SkeletonPill width="w-20" height="h-6" />
        </div>
      </div>

      {/* Action Buttons Footer */}
      <div className="flex items-center justify-end gap-2 p-3 bg-gray-50">
        <SkeletonButton width="w-10" height="h-10" rounded="full" />
        <SkeletonButton width="w-10" height="h-10" rounded="full" />
        <SkeletonButton width="w-10" height="h-10" rounded="full" />
      </div>
    </div>
  );
};

const MobileSkeleton = ({ cardCount = 10 }) => {
  return (
    <div className="space-y-4">
      {Array.from({ length: cardCount }).map((_, index) => (
        <MobileSkeletonCard key={index} />
      ))}
    </div>
  );
};

export default MobileSkeleton;
